import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Close } from '@micromag/core/components';
import Button from '@micromag/element-button';

var styles = {"container":"micromag-element-webview-container","close":"micromag-element-webview-close","iframe":"micromag-element-webview-iframe","top":"micromag-element-webview-top"};

var propTypes = {
  url: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  closeable: PropTypes.bool,
  focusable: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  url: null,
  width: null,
  height: null,
  closeable: false,
  focusable: false,
  onClose: null,
  className: null
};
function WebView(_ref) {
  var url = _ref.url,
    width = _ref.width,
    height = _ref.height,
    closeable = _ref.closeable,
    focusable = _ref.focusable,
    onClose = _ref.onClose,
    className = _ref.className;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty({}, styles.hidden, !focusable), styles.closeable, closeable), className, className !== null)]),
    style: {
      width: width,
      height: height
    }
  }, closeable ? /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.close,
    "aria-label": intl.formatMessage({
      id: "cXt3NU",
      defaultMessage: [{
        "type": 0,
        "value": "Close Popup"
      }]
    }),
    focusable: focusable,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Close, {
    className: styles.closeIcon
  }))) : null, /*#__PURE__*/React.createElement("iframe", {
    className: styles.iframe,
    "aria-hidden": !focusable ? 'true' : null
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: focusable ? '0' : '-1',
    title: intl.formatMessage({
      id: "17zT4Q",
      defaultMessage: [{
        "type": 0,
        "value": "Popup"
      }]
    }),
    src: url || 'about:blank',
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerPolicy: "strict-origin-when-cross-origin",
    allowFullScreen: true
  }));
}
WebView.propTypes = propTypes;
WebView.defaultProps = defaultProps;

export { WebView as default };
